<template>
    <div class="page-bayuerdesk">
        <transition name="page-bayuerdesk__loading">
            <div v-if="isLoadingFilter" class="page-bayuerdesk__loading">
                <base-preloader-gif :size="40"/>
            </div>
        </transition>
        <!--TODO: Удалить как будут готовы уведомления-->
        <!-- <LinceButton @click="createNotification" :theme="'secondary'" style="width: fit-content; margin: 20px auto;">Creat notify</LinceButton> -->
        <kit-panel
            :kits="kitPanelItemsRender"
            :kitCustomIdSelected="kitCustomIdSelected"
            :kitsTableActive="kitsFolderIdsActive"
            :kitsMarkersActive="kitsMarkersActive"
            :isMarginLeft="true"
            :kitCanAdd="!isShare"
            :isShare="isShare"
            :isLoadingKitFound="isLoadingKitFound"
            :isLoadingKitsCustom="isLoadingKitsCustom"
            @onSelectKit="onSelectKit"
            @onCreateKit="onCreateKit"
            @onMatchFromFile="onMatchFromFile"
            @onRenameKit="onRenameKit"
            @onRemoveKit="onRemoveFolder"
            @onToggleTableKit="onToggleTableKit"
            @onToggleMarkersKit="onToggleMarkersKit"
            @onDuplicate="onDuplicate"
            @toggleAdmetrix="toggleAdmetrix"
        />
        <div class="page-bayuerdesk__map-view">
            <div
                :class="{
                    'page-bayuerdesk__map-view-content_half': isFolderFiftySize,
                    'page-bayuerdesk__map-view-content-map': isFolderFiftySize
                }"
                class="page-bayuerdesk-map"
            >
                <ProgressBar
                    :isLoading="isLoadingMap"
                    class="page-bayuerdesk-map__progressbar"
                />
                <div class="page-bayuerdesk-map__wrapper">
                    <!-- <map-view
                        ref="mapView"
                        :markers-statuses="markersStatuses"
                        :isLegendPanel="!isShare"
                        @onSelectMarker="onSelectMarker"
                        @onSelectMarkerRight="onSelectMarkerRight"
                        @onMassSelectMarkers="onMassSelectMarkers"
                        @activeLegendPanel="onChangeMarkers"
                        @onAfterSelectSideInBox="onAfterSelectSideInBox"
                    /> -->
                    <lince-map-view
                        ref="mapView"
                        :isShare="isShare"
                        :markers-statuses="markersStatuses"
                        :isLegendPanel="true"
                        :isLoadingLegend="isLoadingLegend"
                        :legendData="legendData"
                        :legendGroups="legendGroups"
                        :legendItems="legendItems"
                        :legendColorsCustom="legendColorsCustom"
                        @onSelectMarker="onSelectMarker"
                        @onSelectMarkerRight="onSelectMarkerRight"
                        @onMassSelectMarkers="onMassSelectMarkers"
                        @activeLegendPanel="onChangeMarkers"
                        @onAfterSelectSideInBox="onAfterSelectSideInBox"
                        @onSelectLegendGroup="onSelectLegendGroup"
                        @onToggleLegendItem="onToggleLegendItem"
                        @onSelectLegendColor="onSelectLegendColor"
                        @onSelectLegendFigure="onSelectLegendFigure"
                        @addLegendColorCustom="addLegendColorCustom"
                        @removeLegendColorCustom="removeLegendColorCustom"
                        @onMapClick="onMapClick"
                        @onBoundsChanged="onBoundsChanged"
                        @onClickCluster="onClickCluster"
                        @onReadyMap="onReadyMap"
                        @onChangeIconType="onChangeIconType"
                    />

                    <!-- <layout-modules
                        v-if="!isYandexMap"
                        @onToggleGroupPoi="toggleGroupPoi"
                        @onToggleOnePoi="toggleOnePoi"
                        @onTogglePoiAll="togglePoiAll"
                        @onChangeMarkerStylePoi="changeMarkerStylePoi"
                        @onUpdateMarkerPoi="updateMarkerPoi"
                    /> -->

                    <layout-modules
                        ref="layoutModules"
                        :moiPoiCoords="moiPoiCoords"
                        @onDrawPoiMarkers="onDrawPoiMarkers"
                        @onFilterPoiRadius="onFilterPoiRadius"
                        @onClearPoiMarkers="onClearPoiMarkers"
                        @onTogglePoiMarker="onTogglePoiMarker"
                        @onUpdateColorMarkers="onUpdateColorMarkers"
                        @onUpdateIconMarkers="onUpdateIconMarkers"
                        @onTogglePoiAddress="onTogglePoiAddress"
                        @onDrawCompetitorMarkers="onDrawCompetitorMarkers"
                        @onClearCompetitorMarkers="onClearCompetitorMarkers"
                        @onChangeCompetitorColor="onChangeCompetitorColor"
                    />

                    <card-free
                        v-if="isCardVisible"
                        :sides="cardData"
                        :kitPrices="cardKitPrices"
                        :selectedData="cardMarkerSelected"
                        :filterSelectedDates="filterSelectedDates"
                        class="page-bayuerdesk-map__construction-card"
                        @close="onCloseCard"
                        @onCheckPrice="onCheckPrice"
                        @onPanoramaGoogle="onPanoramaGoogle"
                    />

                    <div class="page-bayuerdesk__map-widget-ad-metrix">
                        <MapWidgetAdMetrix
                            :adMetrix="adMetrix"
                            @closeAdMetrix="closeAdMetrix"
                        />
                    </div>
                </div>
            </div>

            <div
                v-if="isFolderFiftySize"
                class="page-bayuerdesk__map-view-resizer"
                @mousedown="onResizeFolder"
            />

            <div
                ref="folderContent"
                :style="folderStylesObj"
                :class="{ 'page-bayuerdesk__map-view-content_half': isFolderFiftySize }"
            >

                <LayoutFolderWithoutPrices
                    :folderId="'-2'"
                    :folderColor="legendItemWithoutPricesColor"
                    :tableColumns="tableColumnsWithoutPrices"
                    :tableRowsCount="withoutPricesSideCountReal"
                    :tableRowsIdsSelected="rowsSelectedWithoutPrices"
                    :isFolderFiftySize="isFolderFiftySize"
                    @checkTableRow="onCheckTableRowWithoutPrices"
                    @clickTableCell="onClickCell"
                    @toggleResizeFolder="toggleResizeFolderMode"
                    @closeFolder="handleCloseFolder"
                />

                <folder
                    v-if="!isShare"
                    :id="kitFound.id"
                    :title="kitFound.title"
                    :isMinimize="false"
                    :width="calculateFolderWidth('found', folderSize)"
                    :height="calculateFolderHeight('found', folderSize)"
                    :top="getPositionFolderKit(kitFound.id, 'top', folderSize)"
                    :left="getPositionFolderKit(kitFound.id, 'left', folderSize)"
                    :color="getColorKit(kitFound.id)"
                    :isRename="false"
                    :isFolderFiftySize="isFolderFiftySize"
                    @click.native="onSelectKit(kitFound.id, 'found')"
                >
                    <template v-slot:summary>
                        <AppFooter class="folder__legend"/>
                    </template>
                    <template v-slot:panel>
                        <FolderControlPanel
                            class="folder__panel"
                            :isFound="true"
                            :isDuplicate="false"
                            :isRemove="false"
                            :isExport="tableRows.length > 0"
                            :isFull="false"
                            :isMinimizeMode="true"
                            @exportExcel="onExportFolder(kitFound.id)"
                            @addAll="onCheckAddAll"
                            @onFullSize="toggleResizeFolder({id: kitFound.id, resize: 'full'})"
                            @onFiftySize="toFiftySizeKitFound"
                            @onCloseFolder="handleCloseFolder(kitFound.id)"
                            @toMinimizeSize="toMinimizeSizeKitFound"
                        />
                    </template>
                    <template v-slot:content>
                        <kit-tab
                            :canCheck="true"
                            :columns="tableColumnsWithoutTags"
                            :modifieredCols="tableColumnsModifered"
                            :datesCols="tableColumnsDates"
                            :tableData="tableRows"
                            :folderId="kitFound.id"
                            :rowsSelected="tableFoundRowsSelected"
                            :rowsSelectedPart="tableFoundRowsSelectedPart"
                            :rowsCheckboxes="tableCustomPricesSelected"
                            :style="{'height': '100%'}"
                            :isProgressBarLoading="isProgressBarLoading"
                            @lazyload="onLazyloadTableDataFound"
                            @filter="onFilterTableDataFound"
                            @sort="onSortTableDataFound"
                            @onCheckSubCheckbox="onCheckSubCheckboxFound"
                            @onCheckRow="onCheckRowFound"
                            @onCheckRowsAll="onCheckRowsAllFound"
                            @onClickCell="onClickCell"
                            @onAddPricesRow="onCheckSubCheckboxFound($event, 'prices', 'add')"
                        />
                    </template>
                </folder>

                <layout-folder
                    v-for="(kit) in kitCustoms"
                    ref="layoutFolder"
                    :key="kit.id"
                    :id="kit.id"
                    :title="kit.title"
                    :folderType="kit.type"
                    :width="calculateFolderWidth('kit', folderSize)"
                    :height="calculateFolderHeight('kit', folderSize)"
                    :left="getPositionFolderKit(kit.id, 'left', folderSize)"
                    :top="getPositionFolderKit(kit.id, 'top', folderSize)"
                    :color="getColorKit(kit.id)"
                    :isRename="true"
                    :isCurrent="String(kitCustomIdSelected) === String(kit.id)"
                    :isRemove="kitCustoms.length > 1"
                    :isDuplicate="!isShare"
                    :currentIconType="currentIconType"
                    :legendData="legendData"
                    :tagList="tagList"
                    :isFolderFiftySize="isFolderFiftySize"
                    :poiRadiusFilter="poiRadiusFilter"
                    @onRenameFolder="onRenameKit"
                    @onClickFolder="onSelectKit"
                    @onCheckSubCheckbox="onCheckSubCheckboxFound($event, 'allPrices')"
                    @beforeGetMarkers="beforeGetMarkers"
                    @afterGetMarkers="afterGetMarkersCustom"
                    @drawMarkers="drawMarkersFound"
                    @removeFolder="onRemoveFolder"
                    @exportFolder="onExportFolder"
                    @moveToBudget="onMoveToBudget"
                    @onDuplicate="onDuplicate"
                    @onClickCell="onClickCell"
                    @onRemovePriceTable="onCheckSubCheckboxFound($event, 'allPrices', 'remove')"
                    @updateKitItem="updateKit"
                    @createTag="onCreateTag"
                    @deleteTags="onDeleteTags"
                    @toggleResizeFolder="toggleResizeFolderMode"
                    @closeFolder="handleCloseFolder"
                    @shareKit="shareKit"
                >
                </layout-folder>
            </div>
        </div>
        <ExportTemplate
            v-if="isExporting"
            :userTemplates="userTemplates"
            :currentTemplate="currentTemplate"
            @onGetTemplates="onGetTemplates"
            @onCloseExportFolder="onCloseExportFolder"
            @onSaveTemplate="onSaveTemplate"
            @onCheckTemplate="onCheckTemplate"
            @onExportTemplate="onExportTemplate"
            @onRemoveTemplate="onRemoveTemplate"
        />
        <layout-match
            v-if="isMatchingFromFile"
            @onClose="onCloseMatching"
            @onComplete="onCompleteMatching"
        />

        <RealtimeSystemMap/>
    </div>
</template>

<script>
import {mapGetters, mapState, mapMutations} from 'vuex';
import BasePreloaderGif from "@/components/Base/BasePreloaderGif.vue";
import LinceMapView from '@/components/MapV3/LinceMapView';
import KitPanel from '@/components/KitPanelV2/KitPanel';
import LayoutFolderWithoutPrices from '@/layouts/LayoutsPageBayuerdesk/LayoutFolderWithoutPrices.vue';
import LayoutFolder from '@/layouts/LayoutsPageBayuerdesk/LayoutFolder';
import LayoutMatch from '@/layouts/LayoutsPageBayuerdesk/LayoutMatch';
import Folder from '@/components/Folder/Folder';
import MixinApi from '@/mixins/MixinsPageBayuerdesk/MixinApi';
import MixinKitFolder from '@/mixins/MixinsPageBayuerdesk/MixinKitFolder';
import MixinKitPanel from '@/mixins/MixinsPageBayuerdesk/MixinKitPanel';
import MixinTableFound from '@/mixins/MixinsPageBayuerdesk/MixinTableFound';
import MixinMapFound from '@/mixins/MixinsPageBayuerdesk/MixinMapFound';
import KitTab from '@/components/HandbookComponents/KitTab';
import CardFree from '@/components/ConstructionCardControllers/CardFree'
import MapWidgetAdMetrix from "@/components/MapWidgets/MapWidgetAdMetrix.vue";
import FolderControlPanel from "@/components/Folder/FolderControlPanel";
import ExportTemplate from "@/components/Export/ExportTemplate";
import MixinExport from "@/mixins/MixinExport";
import MixinMatchingFromFile from "@/mixins/MixinMatchingFromFile";
import ProgressBar from '@/components/Base/ProgressBar';
import LayoutModules from '@/components/MapV2/components/LayoutModules/LayoutModules';
import ServiceMapLegend from '../services/ServicesMap/ServiceMapLegend'
import ServiceMap from '@/services/ServicesMap/ServiceMap.js';
import AppFooter from '../components/ConstructionCard/ConstructionCardFree/Components/Footer.vue';
import MixinActionMapCache from "@/mixins/MixinActionMapCache";
import RealtimeSystemMap from "@/components/MapV2/RealtimeSystem/RealtimeSystemMap";
import ServiceKitSideTag from '@/services/ServicesKit/ServiceKitSideTag.js';
import ServiceTableBase from '@/services/ServicesTable/ServiceTableBase.js';

import MarkerManager from "../managers/MarkerManager";
import UtilMarker from "../utils/UtilMarker";

export default {
    name: 'PageBayuerdeskV2',
    components: {
        RealtimeSystemMap,
        BasePreloaderGif,
        LinceMapView,
        KitPanel,
        LayoutFolderWithoutPrices,
        LayoutFolder,
        LayoutMatch,
        Folder,
        KitTab,
        CardFree,
        MapWidgetAdMetrix,
        FolderControlPanel,
        ExportTemplate,
        ProgressBar,
        LayoutModules,
        AppFooter
    },
    mixins: [
        MixinApi,
        MixinKitFolder,
        MixinKitPanel,
        MixinTableFound,
        MixinMapFound,
        MixinExport,
        MixinMatchingFromFile,
        MixinActionMapCache
    ],
    /**
     * Входные данные компонента
     * @property {Boolean} isShare - условие шары
     */
    props: {
        isShare: {
            type: Boolean,
            default: false
        }
    },
    /**
     * Данные компонента
     * @property {String} isProgressBarLoading - Показать/скрыть preloader страницы при загрузке
     * @property {String} isLoadingFilter - статус инициализации фильтра
     * @property {Array} markersStatuses - список статусов маркеров
     * @property {Object} activeLegendPanelMarkersStatuses - список выбранных статусов маркеров в базовой легенде
     * @property {String} currentSelectionSideMode - режим выбора конструкции с карт
     */
    data: () => ({
        isProgressBarLoading: false,
        isLoadingFilter: false,
        isLoadingKitFound: false,
        isLoadingKitsCustom: false,
        isLoadingMap: false,
        markersStatuses: [],
        mapDriver: 'google',
        isWithoutPrices: false,
        moiPoiCoords: [],
        legendScheme: {
            found: {
                title: "Легенда найденого",
                groupSelected: "status",
            },
            custom: {
                title: "Легенда наборов",
                groupSelected: "default",
            },
            without_prices: {
                title: "Легенда без цен",
                groupSelected: "default",
            }
        },
        legendData: {},
        legendGroups: [],
        legendItems: [],
        isLoadingLegend: false,
        legendTypesMap: {
            found: 0,
            custom: 1,
            without_prices: 2
        },
        legendKeysMap: {
            0: 'found',
            1: 'custom',
            2: 'without_prices'
        },
        legendColorsCustom: [],
        isUpdateLegend: true,
        currentCityId: null,

        isFirstStart: true,
        poiRadius: 0,
        poiPointsDetailed: {},
        tagList: [],
        tagListRequestData: {
            page: 1,
            perPage: 40,
            pageCount: 1
        },
        legendItemWithoutPricesBuffer: {},
        folderResizeMode: 'minimize',
        folderWidth: '50%',
        adMetrix: []
    }),

    computed: {
        /** Проксируем состояния из стора */
        ...mapState({
            filterSelectedData: state => state.filter.filterSelectedData,
            tableCustomPricesSelected: state => state.kit.tableCustomPricesSelected,
            tableCustomRows: state => state.kit.tableCustomRows,
            withoutPricesStepCount: state => state.filter.withoutPricesStepCount,
            withoutPricesSideCount: state => state.filter.withoutPricesSideCount,
            withoutPricesSideCountReal: state => state.filter.withoutPricesSideCountReal,
            isFilterLoading: state => state.filter.isFilterLoading,
            activeLegendPanelMarkersStatuses: state => state.pageBayuerdesk.activeLegendPanelMarkersStatuses,
            allActiveLegendPanelMarkersStatuses: state => state.pageBayuerdesk.allActiveLegendPanelMarkersStatuses,
            markersStatusesListDefault: state => state.pageBayuerdesk.markersStatusesListDefault,
            filterLocations: state => state.filter.filterLocations
        }),
        ...mapGetters('pageBayuerdesk', ['onlyWithoutPrice']),
        ...mapGetters('filter', ['currentCity']),
        ...mapGetters('widgetPoi', [
            'dataPoints',
            'checkedParentList',
            'checkedChildList',
        ]),

        currentIconType() {
            return this.markerManager.getCurrentIconType();
        },

        isFolderFiftySize() {
            return this.folderResizeMode === 'fifty' && this.kitsFolderIdsActive.length > 0;
        },
        folderStylesObj() {
            return this.isFolderFiftySize ? { 'width':  this.folderWidth } : {};
        },
        rowsSelectedWithoutPrices() {
            return this.tableCustomRows.map(row => String(row?.catalog_id ?? ''));
        },
        tableColumnsWithoutTags() {
            return this.tableColumns.filter(column => String(column?.prop ?? '') !== 'sideTags');
        },
        tableColumnsWithoutPrices() {
            return [
                ...this.tableColumnsWithoutTags,
                {
                    canSearch: false,
                    canSorted: false,
                    isModifiered: false,
                    isSlot: false,
                    label: 'Источник',
                    prop: 'source_name',
                }
            ]
        },
        /** Проксируем геттеры из стора */
        // ...mapGetters('kit', ['tableFoundRowsSelected']),
        filterSelectedDates() {
            return this.filterSelectedData?.date ?? [];
        },
        /**
         * Выбранные строки текущего набора
         * @returns {Array}
         */
        tableFoundRowsSelected() {
            let tableFoundRowsSelected = [];
            Object.keys(this.tableCustomPricesSelected).forEach(rowId => {
                const datesPrices = this.tableCustomPricesSelected[rowId] || [];
                const {date: datesFilter = []} = this.filterSelectedData;
                const datesPricesFiltered = datesPrices.filter(date => datesFilter.includes(date));
                if (datesPricesFiltered.length !== 0)
                    tableFoundRowsSelected.push(rowId);
            });
            return tableFoundRowsSelected;
        },
        /**
         * Частично выделенные строки
         * @returns {Array}
         */
        tableFoundRowsSelectedPart() {
            const tableFoundRowsSelectedPart = this.tableFoundRowsSelected.filter(id => {
                let isFilter = false;
                const row = this.tableRows.find(row => String(row.id) === String(id));
                if (typeof row !== 'undefined') {
                    const {prices = []} = row;
                    const isEvery = prices.every(price => this.tableCustomPricesSelected[id].includes(price.date));
                    isFilter = !isEvery;
                }
                return isFilter;
            });
            return tableFoundRowsSelectedPart;
        },
        /**
         * Выделеные маркеры найдено
         * @returns {Array}
         */
        mapFoundMarkersSelectedIds() {
            const tableCustomRowsFiltered = this.tableCustomRows.filter(row => {
                const {id = -1} = row;
                return this.tableFoundRowsSelected.includes(String(id));
            });
            const mapFoundMarkersSelectedIds = tableCustomRowsFiltered.map(row => {
                const {marker_id = '-1'} = row;
                return marker_id;
            });
            return mapFoundMarkersSelectedIds;
        },
        mapWithoutPriceSelectedCatalogIds() {
            let index = this.kitCustoms.findIndex(kit => String(kit.id) === this.kitCustomIdSelected);
            return this.$refs.layoutFolder[index].tableRowsCatalogIdsSelected || [];
        },
        isYandexMap() {
            return this.mapDriver === 'yandex';
        },
        kitItemsMarkersActive() {
            return this.kitPanelItems.filter(kitItem => this.kitsMarkersActive.includes(String(kitItem?.id ?? '')));
        },
        kitTypesMarkersActive() {
            return this.kitItemsMarkersActive.reduce((kitItemsTypes, kitItem) => {
                const {type = ''} = kitItem;
                if (!kitItemsTypes.includes(String(type)))
                    kitItemsTypes.push(String(type));

                return kitItemsTypes;
            }, []);
        },
        legendDataTypes() {
            return Object.keys(this.legendData);
        },
        kitIdsCustoms() {
            return this.kitCustoms.map(kit => String(kit?.id ?? ''));
        },
        kitsCustomMarkersActive() {
            return this.kitsMarkersActive.filter(kitId => this.kitIdsCustoms.includes(String(kitId)));
        },

        poiPoints() {
            return Object.values(this.poiPointsDetailed).map((point) => {
                const {lat = 0, lng = 0} = point;
                return {lat, lng};
            })
        },
        legendItemWithoutPrices() {
            return this.legendItems?.find(legendItem => String(legendItem?.legendKey ?? '') === 'without_prices') ?? {};
        },
        legendItemWithoutPricesCount() {
            return parseInt(this.legendItemWithoutPrices?.count ?? this.legendItemWithoutPricesBuffer?.count);
        },
        legendItemWithoutPricesColor() {
            return `#${ this.legendItemWithoutPrices?.color ?? this.legendItemWithoutPricesBuffer?.color }`;
        },
        kitPanelItemWithoutPrices() {
            return {
                id: '-2',
                type: 'without_prices',
                title: 'Без цен',
                description: this.legendItemWithoutPricesCount,
                color: this.legendItemWithoutPricesColor
            };
        },
        kitPanelItemsRender() {
            return this.isWithoutPrices ? [...this.kitPanelItems, this.kitPanelItemWithoutPrices] : this.kitPanelItems;
        },
        poiRadiusFilter() {
            return { radius: this.poiRadius, points: this.poiPoints }
        },

        isWithoutPricesMarkersActive() {
            return this.kitsMarkersActive.includes('-2');
        },

        isFoundMarkersActive() {
            return this.kitsMarkersActive.includes(this.kitFoundId);
        },

        activeMarkerKitIds() {
            return this.kitsMarkersActive.filter(kitId => kitId !== this.kitFoundId && kitId !== '-2')
        }
    },
    watch: {
        /** Следим за изменением фильтра и подтягиваем найдено */
        filterSelectedData() {
            this.toggleTableAndMap();

            ServiceMapLegend.getLegendGroupsWithoutPrices(this.filterSelectedData, 'default', this.kitPanelItems, (legendGroups) => {
                const legendGroupDefault = legendGroups[0] ?? {};
                this.legendItemWithoutPricesBuffer = { ...legendGroupDefault };
            }, () => {});
        },
        filterLocations() {
            this.toggleTableAndMap();
        },

        /** Следим за изменениями выделенных строк найдено и обновляем маркеры */
        // eslint-disable-next-line no-unused-vars
        tableFoundRowsSelected(tableFoundRowsSelectedNew, tableFoundRowsSelectedOld) {
            this.setMarkersSelectFound(this.kitFoundId);
            this.setMarkersSelectWithoutPrice();

            // const index = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));

            // if (!lodash.isEqual(tableFoundRowsSelectedNew, tableFoundRowsSelectedOld)) {
            //     this.$refs.layoutFolder[index].updateMarkers();
            //     this.$refs.layoutFolder[index].postSummaryData();
            // }
        },

        kitsMarkersActive() {
            if (this.isUpdateLegend)
                this.updateLegend();
        },

        // isWithoutPrices() {
        //     this.isUpdateLegend = false;

        //     if (this.isWithoutPrices)
        //         this.kitsMarkersActive.push('without_prices');
        //     else
        //         this.kitsMarkersActive = this.kitsMarkersActive.filter(kitId => String(kitId) !== 'without_prices');
        // }
    },
    beforeMount() {
        // if (!this.isShare)
        //     this.isLoadingFilter = true;
        if (localStorage.getItem('mapDriver'))
            this.mapDriver = localStorage.getItem('mapDriver');

        this.initTable();
    },
    mounted() {
        this.markerManager = MarkerManager.getInstance(this.$refs.mapView);
        this.markerManager.map = this.$refs.mapView;

        this.isLoadingKitFound = true;
        this.isLoadingKitsCustom = true;
        this.setIsShare(this.isShare);
        /** При монтировании получаем список наборов */
        this.isLoadingKitsCustom = true;
        this.postKitsList((kits) => {
            this.afterPostKitsList(kits);
            // this.onToggleTableKit(this.kitFoundId, 'found');

            if (this.isShare) {
                this.postCalculateSetBound([this.kitCustomIdSelected], (result) => {
                    const {bound = [], view_zoom: viewZoom = 10} = result;
                    if (bound.length) {
                        this.$refs.mapView.focusMap(
                            (bound[0][0] + bound[1][0]) / 2,
                            (bound[0][1] + bound[1][1]) / 2,
                            viewZoom
                        );
                    }

                    this.$nextTick(() => {
                        this.onToggleMarkersKit(this.kitCustomIdSelected, 'custom');
                        this.onToggleTableKit(this.kitCustomIdSelected, 'custom');
                        // this.updateLegend("custom");
                        this.onTriggerBounds();
                    });
                })

            } else {
                this.onToggleMarkersKit(this.kitFoundId);
            }
            this.isLoadingKitsCustom = false;
        });
        this.setCurrentComponent('PageBuyerdesk');

        this.getTagList();

        ServiceMapLegend.getLegendGroupsWithoutPrices(this.filterSelectedData, 'default', this.kitPanelItems, (legendGroups) => {
            const legendGroupDefault = legendGroups[0] ?? {};
            this.legendItemWithoutPricesBuffer = { ...legendGroupDefault };
        }, () => {});

        this.getLegendColors();
    },
    methods: {
        ...mapMutations(['setCurrentComponent', 'setIsShare']),
        ...mapMutations('pageBayuerdesk', [
            'setAllActiveMarkerStatuses',
            'setActiveMarkerStatuses',
            'setMarkersStatusesListDefault',
        ]),
        ...mapMutations('history', [
            'addHistoryItem',
        ]),
        ...mapMutations('widgetPoi', [
            'setWidgetPoi',
        ]),
        /** Получаем методы для папок */
        ...mapMutations('folders', ['toggleResizeFolder', 'closeFolder']),

        async initTable() {
            const mapState = await ServiceMap.getMapState();
            const tableResizeMode = !this.isShare ? ServiceTableBase.getTableResizeMode() : mapState?.table?.tableResizeMode ?? 'minimize';

            this.toggleResizeFolderMode(tableResizeMode);
        },

        async shareKit(shareToken = '') {
            const mapDriver = localStorage.getItem('mapDriver') ?? "google";
            const tableResizeMode = ServiceTableBase.getTableResizeMode();

            await ServiceMap.setMapState({
                type: "share",
                shareToken,
                mapState: {
                    mapDriver,
                    table: { tableResizeMode }
                }
            });
        },

        handleCloseFolder(kitId = null) {
            if (kitId)
                this.closeFolder(this.id);

            this.$nextTick(() => this.$refs?.mapView?.fitToViewportMap());
        },

        onResizeFolder(event) {

            document.body.style.userSelect = 'none';
            const target = this.$refs.folderContent;
            const startPoint = event.clientX;
            const startWidth = target.offsetWidth;

            const onResizeFolderEnd = (event) => {
                const difference = event.clientX - startPoint;
                const folderWidth = `${startWidth - difference}px`;
                target.style.width = folderWidth;
                this.folderWidth = folderWidth;

                this.$refs.mapView?.fitToViewportMap();
            };

            document.addEventListener('mousemove', onResizeFolderEnd);
            document.addEventListener('mouseup', () => {
                document.removeEventListener('mousemove', onResizeFolderEnd);
                document.body.style.userSelect = 'initial';
            }, { once: true });
        },
        toggleResizeFolderMode(resize = '', id = '') {
            if (resize === 'fifty') {
                const kitsFolderIdsActiveToClose = this.kitsFolderIdsActive.filter(kitId => kitId !== id);
                kitsFolderIdsActiveToClose.forEach((kitId) => this.onToggleTableKit(kitId));
            }

            this.folderResizeMode = resize;

            ServiceTableBase.setTableResizeMode(resize);

            this.$nextTick(() => this.$refs?.mapView?.fitToViewportMap());
        },
        toFiftySizeKitFound() {
            this.toggleResizeFolder({ id: this.kitFound.id, resize: 'fifty' });
            this.toggleResizeFolderMode('fifty', this.kitFound.id);
        },
        toMinimizeSizeKitFound() {
            this.toggleResizeFolder({ id: this.kitFound.id, resize: 'minimize' });
            this.toggleResizeFolderMode('minimize');
        },
        async getTagList() {
            try {
                const { tagList = [], pageCount = 1 } = await ServiceKitSideTag.getTagList(this.tagListRequestData);
                this.tagList.push(...tagList);
                this.tagListRequestData.pageCount = parseInt(pageCount);
                this.tagListRequestData.page += 1;
            } catch (error) {
                console.log(error);
                // this.$notify.addNotification({
                //     type: 'error',
                //     title: 'Ошибка получения списка тегов',
                //     description: error,
                //     duration: Infinity,
                //     position: 'bottom-right'
                // });
            }
        },
        onCreateTag(tag = {}, sideId = -1) {
            const tagName = String(tag?.value ?? '');

            this.createTag(tagName, sideId);
        },
        onDeleteTags(tagsIds = []) {
            this.deleteTags(tagsIds);
        },
        async createTag(tagName = '', sideId = -1) {
            try {
                const tag = await ServiceKitSideTag.createTag(tagName);

                this.createTagAfter(tag, sideId);
            } catch (error) {
                this.$notify.addNotification({
                    type: 'error',
                    title: 'Ошибка создания тега',
                    description: error,
                    duration: Infinity,
                    position: 'bottom-right'
                });
            }
        },
        createTagAfter(tag = {}, sideId = -1) {
            this.tagList.push(tag);

            const indexFolder = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));
            this.$refs.layoutFolder[indexFolder]?.selectTags({ action: 'link', tagsIds: [parseInt(tag?.id ?? -1)], sidesIds: [parseInt(sideId)], isSelectedAll: false });
        },
        async deleteTags(tagsIds = []) {
            try {
                await ServiceKitSideTag.deleteTags(tagsIds);

                this.deleteTagsAfter(tagsIds);
            } catch (error) {
                this.$notify.addNotification({
                    type: 'error',
                    title: 'Ошибка удаления тегов',
                    description: error,
                    duration: Infinity,
                    position: 'bottom-right'
                });
            }
        },
        deleteTagsAfter(tagsIds = []) {
            this.tagList = this.tagList.filter(tag => !tagsIds.includes(parseInt(tag?.id ?? -1)));
        },
        // TODO: Удалить как будут готовы уведомления
        // createNotification() {
        //     this.$notify.addNotification({
        //         type: (['default', 'success', 'error', 'warning'][Math.floor(Math.random() * (3 - 0 + 1)) + 0]),
        //         title: '<a href="https://element-plus.org/en-US/component/notification.html#notification" style="color: #4A92F6">Какая-то ссылка</a>',
        //         description: '<p>This is a <em>default</em> message!</p>',
        //         duration: Infinity,
        //         position: 'bottom-right'
        //     });
        // },

        /** Меняем состояние показа таблицы и карты */
        toggleTableAndMap() {
            const isChangedCity = this.checkMapScale();

            if (this.isWithoutPrices !== !!this.filterSelectedData.without_prices) {
                this.isWithoutPrices = !!this.filterSelectedData.without_prices;
                this.$refs.layoutFolder.forEach((folder, key) => {
                    this.$refs.layoutFolder[key].tableRows = Object.assign([])
                    this.$refs.layoutFolder[key].getTableRows();
                });
            }

            this.isLoadingKitFound = true;
            this.tableRows = [];
            this.tableFoundPageNumber = 1;
            this.postTableDataFound(this.tableFoundRequestBody, (count, rows) => {
                this.setDescriptionKitFound(this.withoutPricesSideCount);
                this.afterPostTableData(rows, 'prices', true);
                this.isLoadingKitFound = false;
            });

            // this.isLoadingMap = true;

            if (!this.isFirstStart && !isChangedCity) {
                this.onToggleMap();
            }

            if (!this.isFirstStart) {
                this.updateLegend("found");
            }

            if (this.isWithoutPrices) {
                this.updateLegend("without_prices");
            }

            this.isFirstStart = false;
        },

        /**
         * Дергаем масштаб масштаб
         */
        onTriggerBounds() {
            try {
                this.onBoundsChanged(
                    this.$refs.mapView.getBounds(),
                    this.$refs.mapView.getZoom(),
                    true
                );
            } catch (e) {
                console.log(this.$refs.mapView)
                throw e
            }

        },

        /**
         * Меняем состояние показа карты
         */
        onToggleMap() {
            switch (true) {
                case (!this.isShare && this.isReadyMap):
                    console.log("сразу");
                    this.onTriggerBounds();
                    break;
                case (!this.isShare && !this.isReadyMap):
                    console.log("ждем");
                    this.addTrigger(() => this.onTriggerBounds());
                    break;
            }
        },

        async updateLegend(targetType = null) {
            this.isLoadingLegend = true;

            this.getLegendData();
            await Promise.all([
                await this.getLegendAttributes(),
                await this.getLegendGroups(targetType)
            ]);

            this.isLoadingLegend = false;

            this.updateLegendMarkersColors();
        },
        getLegendData() {
            let kitTypesMarkersActive = [...this.kitTypesMarkersActive];
            if (this.isWithoutPrices && this.isWithoutPricesMarkersActive)
                kitTypesMarkersActive.push("without_prices");

            if (kitTypesMarkersActive.length !== this.legendDataTypes.length) {
                const legendDataBuffer = {...this.legendData};
                this.legendData = kitTypesMarkersActive.reduce((legendData, type) => {
                    legendData[type] = legendDataBuffer[type] ? legendDataBuffer[type] : this.legendScheme[type] ?? {};
                    return legendData;
                }, {});
            }
        },
        async getLegendAttributes() {
            if (this.legendGroups.length === 0)
                await ServiceMapLegend.getLegendAttributes((legendAttributes, selected) => {
                    this.legendGroups = [...legendAttributes]

                    if(selected !== 'default' && selected !== null){
                        this.legendData = {
                            ...this.legendData,
                            custom: {
                                ...this.legendData?.custom,
                                groupSelected: String(selected)
                            }
                        }
                    }

                }, () => {});
        },

        /**
         * Получаем данные для легенды
         * @param targetType
         * @returns {Promise<void>}
         */
        async getLegendGroups(targetType = null) {
            if(targetType === null){
                this.legendItems = [];
            }else{
                const filteredLegendItems = this.legendItems.filter(item => item.legendKey !== targetType);
                this.legendItems = [...filteredLegendItems];
            }

            const isNeedUpdateFound = targetType === null || targetType === 'found';
            const isNeedUpdateCustom = targetType === null || targetType === 'custom';
            const isNeedUpdateWithoutPrices = targetType === null || targetType === 'without_prices';

            if (this.legendData.found && isNeedUpdateFound)
                await this.getLegendGroupsFound();
            if (this.legendData.custom && isNeedUpdateCustom)
                await this.getLegendGroupsCustom();
            if (this.legendData.without_prices && isNeedUpdateWithoutPrices)
                await this.getLegendGroupsWithoutPrices();
        },

        async getLegendGroupsFound() {
            await ServiceMapLegend.getLegendGroupsFound(this.filterSelectedData, String(this.legendData.found?.groupSelected ?? ''), this.kitPanelItems, (legendGroups) => {
                this.filterLegendItems('found');
                this.getLegendGroupsAfter(legendGroups);
            }, () => {});
        },

        async getLegendGroupsWithoutPrices() {
            await ServiceMapLegend.getLegendGroupsWithoutPrices(this.filterSelectedData, String(this.legendData.without_prices?.groupSelected ?? ''), this.kitPanelItems, (legendGroups) => {
                this.filterLegendItems('without_prices');
                this.getLegendGroupsAfter(legendGroups);
            }, () => {});
        },

        async getLegendGroupsCustom() {
            await ServiceMapLegend.getLegendGroupsCustom(this.kitsCustomMarkersActive, String(this.legendData.custom?.groupSelected ?? ''), this.kitPanelItems, (legendGroups) => {
                this.filterLegendItems('custom');
                this.getLegendGroupsAfter(legendGroups);
            }, () => {});
        },

        getLegendGroupsAfter(legendGroups = []) {
            this.legendItems.push(...legendGroups);
        },
        filterLegendItems(legendKey = '') {
            this.legendItems = this.legendItems.filter(legendItem => String(legendItem?.legendKey) !== String(legendKey));
        },

        updateLegendMarkersColors(targetLegendKey = null) {
            this.legendItems.forEach(legendItem => {
                const {active = false, id = '', legendKey = '', attribute = '', color = '', figure = ''} = legendItem;

                if(
                    targetLegendKey !== null
                    && targetLegendKey !== legendKey
                ){
                    return;
                }

                const groupId = UtilMarker.resolveGroupId(id, legendKey, attribute);

                this.markerManager.updateLegendMarkers({
                    attribute, legendKey, groupId, color, figure, active
                });
            });
        },

        async onSelectLegendGroup(legendKey = '', groupId = '') {
            this.isLoadingLegend = true;

            this.legendData = {
                ...this.legendData,
                [legendKey]: {
                    ...this.legendData[legendKey],
                    groupSelected: String(groupId)
                }
            };

            if (legendKey === 'found')
                await this.getLegendGroupsFound();
            if (legendKey === 'custom')
                await this.getLegendGroupsCustom();
            if (legendKey === 'without_prices')
                await this.getLegendGroupsWithoutPrices();

            this.isLoadingLegend = false;

            this.updateLegendMarkersColors();

            this.setFilterPoiRadiusDefault();
        },
        async putLegendEditStyle(type = -1, itemId = '', attribute = '', color = '', figure = '') {
            await ServiceMapLegend.putLegendEditStyle(type, itemId, attribute, color, figure, () => {
                const legendItemId = `${this.legendKeysMap[type] ?? ''}--${attribute}--${itemId}`;
                const legendItemIndex = this.legendItems.findIndex(legendItem => String(legendItem?.id ?? '') === legendItemId);
                if (legendItemIndex !== -1) {
                    const legendItemNew = {
                        ...this.legendItems[legendItemIndex],
                        color: String(color),
                        figure: String(figure)
                    };
                    this.legendItems.splice(legendItemIndex, 1, {...legendItemNew});
                }

                if (String(attribute) === 'default') {
                    const kitItemIndex = this.kitPanelItems.findIndex(kitItem => String(kitItem?.id) === String(itemId));
                    if (kitItemIndex !== -1) {
                        const kitItemNew = {
                            ...this.kitPanelItems[kitItemIndex],
                            color: `#${String(color)}`,
                        };
                        this.kitPanelItems.splice(kitItemIndex, 1, {...kitItemNew});
                    }
                }

                this.updateLegendMarkersColors();
            }, () => {});
        },

        getLegendDataEditStyle(legendData = {}) {
            const {id = '', legendKey = '', attribute = '', figure = '', color = ''} = legendData;
            const type = parseInt(this.legendTypesMap[legendKey] ?? -1);
            let itemId = String(id).split('--')[2] ?? '';

            return {type, itemId, attribute, color, figure};
        },

        async onSelectLegendColor(legendData = {}, color = ''){
            const {type = '', itemId = '', attribute = '', figure = ''} = this.getLegendDataEditStyle(legendData);
            await this.putLegendEditStyle(type, itemId, attribute, color, figure);
        },

        async getLegendColors() {
            this.legendColorsCustom = await ServiceMapLegend.getLegendColors();
        },

        async addLegendColorCustom(legendData = {}, color = '') {
            await this.onSelectLegendColor(legendData, color);
            await this.getLegendColors();
        },

        async removeLegendColorCustom(color = '') {
            await ServiceMapLegend.removeLegendColor(color);
            await this.getLegendColors();
        },

        async onSelectLegendFigure(legendData = {}, figure = ''){
            const {type = '', itemId = '', attribute = '', color = ''} = this.getLegendDataEditStyle(legendData);
            await this.putLegendEditStyle(type, itemId, attribute, color, figure);
        },

        onToggleLegendItem(legendData = {}) {
            const {legendItemId = '', active = false, group: attribute = '', legendKey = ''} = legendData;
            const legendItemIndex = this.legendItems.findIndex(legendItem => String(legendItem?.id ?? '') === String(legendItemId));
            if (legendItemIndex !== -1) {
                const legendItemNew = {
                    ...this.legendItems[legendItemIndex],
                    active: !active
                };
                this.legendItems.splice(legendItemIndex, 1, legendItemNew);
            }

            const {color = '', figure = ''} = this.legendItems[legendItemIndex];
            const groupId = UtilMarker.resolveGroupId(legendItemId, legendKey, attribute);

            this.markerManager.updateLegendMarkers({
                attribute, legendKey, groupId, color, figure, active: !active
            });
        },

        /**
         * Ключить панораму гугл
         * @param {String} lat - широта
         * @param {String} lng - долгота
         */
        onPanoramaGoogle(lat = null, lng = null) {
            this.$refs.mapView.setStreetView(lat, lng);
        },

        /**
         * Событие выделения набора
         * @param {String} id - идентификатор элемента набора
         * @param {String} type - тип элемента набора (found|custom)
         */
        onSelectKit(id = '-1', type = '') {
            if (id !== this.kitFoundId && id !== this.kitCustomIdSelected) {
                if (this.kitsMarkersActive.includes(String(this.kitCustomIdSelected)))
                    this.onToggleMarkersKit(this.kitCustomIdSelected, 'custom');
                if (this.kitsFolderIdsActive.includes(this.kitCustomIdSelected))
                    this.onToggleTableKit(this.kitCustomIdSelected, 'custom');
                this.selectKit(id, type);
                this.onToggleMarkersKit(id, type);
                this.onToggleTableKit(id, type);
                this.bringToFront(id);
            }
        },
        /**
         * Событие создания набора
         */
        onCreateKit() {
            console.log('createKit');
            const newKit = this.createKit();
            this.postCreateKit(newKit, (kit) => {
                this.afterPostCreateKit(kit);
            });
        },
        /**
         * Событие переименования набора
         * @param {String} id - идентификатор набора
         * @param {String} newName - новое название
         */
        onRenameKit(id = '-1', newName = '') {
            const postData = {set_id: id, name: newName};
            this.postRenameKit(postData, (id, newName) => {
                this.afterPostRenameKit(String(id), String(newName));
            });
        },
        /**
         * Событие переключение показа таблицы набора
         * @param {String} id - идентификатор набора
         * @param {String} type - тип набора
         */
        onToggleTableKit(id = '-1', type = '') {
            if (this.isFolderFiftySize) {
                const kitsFolderIdsActiveToClose = this.kitsFolderIdsActive.filter(kitId => kitId !== id);
                kitsFolderIdsActiveToClose.forEach((kitId) => this.onToggleTableKit(kitId));

                if (id === this.kitFoundId) {
                    this.toFiftySizeKitFound();
                }
            }

            if (id !== this.kitFoundId && id !== this.kitCustomIdSelected && type !== 'without_prices') {
                if (this.kitsFolderIdsActive.includes(this.kitCustomIdSelected))
                    this.onToggleTableKit(this.kitCustomIdSelected, 'custom');
            }
            this.selectKit(id, type);
            this.toggleFolder(String(id), type);

            this.$nextTick(() => this.$refs.mapView?.fitToViewportMap());
        },
        /**
         * Событие переключения показа маркеров набора
         * @param {String} id - идентификатор набора
         * @param {String} type - тип набора
         */
        onToggleMarkersKit(id = '-1', type = '') {
            if (type === 'without_prices') {
                if (this.kitsMarkersActive.includes(String(id))) {
                    this.markerManager.removeObjects('-2');
                    this.kitsMarkersActive = this.kitsMarkersActive.filter(kitId => String(kitId) !== '-2');
                    let legendDataBuffer = { ...this.legendData };
                    delete legendDataBuffer.without_prices;
                    this.legendData = { ...legendDataBuffer };
                } else {
                    this.kitsMarkersActive.push('-2');
                    this.onTriggerBounds();
                }
            } else {
                this.isLoadingMap = false;
                this.selectKit(id, type);
                if (!this.kitsMarkersActive.includes(String(id))) {
                    this.kitsMarkersActive.push(String(id));
                }
                else {
                    this.kitsMarkersActive.splice(this.kitsMarkersActive.findIndex(kitId => String(kitId) === String(id)), 1);

                    if (String(id) === this.kitFoundId) {
                        if (this.activeLegendPanelMarkersStatuses.includes('without_price')) {
                            this.markersStatuses = this.onlyWithoutPrice;
                            this.setActiveMarkerStatuses(['without_price']);
                        }
                        if (!this.activeLegendPanelMarkersStatuses.includes('without_price')) {
                            this.markersStatuses = this.onlyWithoutPrice;
                            this.setActiveMarkerStatuses([]);
                        }

                        this.markerManager.removeObjects(this.kitFoundId)
                        this.onChangeMarkers();
                    } else {
                        this.markerManager.removeObjects(this.kitFoundId)
                    }

                }

                this.onToggleMap();
            }

        },
        /**
         * Событие ленивой загрузки найдено
         */
        onLazyloadTableDataFound() {
            this.isProgressBarLoading = true;
            this.tableFoundPageNumber += 1;
            this.postTableDataFound(this.tableFoundRequestBody, (_, rows) => {
                this.afterLazyloadTableDataFound(rows);
                this.isProgressBarLoading = false;
            });
        },
        /**
         * Событие фильтрации по столбцам найдено
         * @param {Object} dataFilter - данные фильтра по столбцам
         */
        onFilterTableDataFound(dataFilter = {}) {
            this.beforeFilterTable(dataFilter);
            this.tableFoundPageNumber = 1;
            this.postTableDataFound(this.tableFoundRequestBody, (_, rows) => {
                this.afterPostTableData(rows, 'prices', true);
            });
        },
        /**
         * Событие сортировки в найдено
         * @param {Object} dataSort - данные сортировки
         */
        onSortTableDataFound(dataSort = {}) {
            this.beforeSortTable(dataSort);
            this.tableFoundPageNumber = 1;
            this.postTableDataFound(this.tableFoundRequestBody, (_, rows) => {
                this.afterPostTableData(rows, 'prices', true);
            });
        },
        /**
         * Событие массового выбора строк найдено
         * @param {Boolean} isSelected - значение флага массового выбора
         */
        onCheckRowsAllFound(isSelected = false) {
            const rowsIds = this.tableRows.map(row => {
                const {id = ''} = row;
                return String(id);
            });
            const priceIds = this.tableRows.reduce((priceIdsAccumulator, row) => {
                const {prices = []} = row;
                const priceIdsCurrent = prices.filter(price => {
                    return isSelected ? String(price?.status ?? '') !== 'busy' : true;
                }).map(price => {
                    const {id = ''} = price;
                    return String(id);
                });

                return [...priceIdsAccumulator, ...priceIdsCurrent];
            }, []);
            const action = isSelected ? 'add' : 'remove';
            const postData = {set_id: this.kitCustomIdSelected, action, ids: priceIds};
            this.postSyncDataCustom(postData, () => {
                const postData = {set_id: this.kitCustomIdSelected, selected: rowsIds};
                this.postTableDataRow(postData, (rows, kitItem) => {
                    this.updateKit(kitItem);
                    rowsIds.forEach(rowId => {
                        this.afterPostTableDataRow(rows, action, rowId);
                    });
                    const sideIds = this.cardData.map(card => String(card.id));
                    this.updateCardMarkersSelected(sideIds, this.getSelectedTableRows());
                });
            });
        },
        getSelectedTableRows(){
            const {extraData = {}} = this.cardMarker;
            const {kitId = '-1'} = extraData;
            let tableRowsPricesIdsSelected;
            let index = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));
            if(kitId == '-2'){
                tableRowsPricesIdsSelected  = this.$refs.layoutFolder[index].tableRowsCatalogIdsPricesSelected || {};
            }else{
                // let index = this.kitCustoms.findIndex(kit => String(kit.id) === String(String(kitId) === this.kitFoundId ? this.kitCustomIdSelected : kitId));
                tableRowsPricesIdsSelected = this.$refs.layoutFolder[index].tableRowsPricesIdsSelected || [];
            }
            return tableRowsPricesIdsSelected;
        },
        /**
         * Событие выбора строки найдено
         * @property {Object} checkData - данные выбора
         */
        onCheckRowFound(checkData = {}) {
            const {rowIsSelected = false, row = {}} = checkData;
            const {id: rowId = -1, prices = []} = row;
            const currentPricesSelected = this.tableCustomPricesSelected[rowId] || [];
            const priceIds = prices.filter(price => {
                const {date = ''} = price;
                const isPriceBusy = String(price?.status ?? '') === 'busy';
                if (rowIsSelected)
                    return !currentPricesSelected.includes(date) && !isPriceBusy;
                else
                    return currentPricesSelected.includes(date);
            }).map(price => price.id);
            const action = rowIsSelected ? 'add' : 'remove';
            const postData = {set_id: this.kitCustomIdSelected, action, ids: priceIds};
            this.postSyncDataCustom(postData, () => {
                const postData = {set_id: this.kitCustomIdSelected, selected: [rowId]};
                this.postTableDataRow(postData, (rows, kitItem) => {
                    this.updateKit(kitItem);
                    this.afterPostTableDataRow(rows, action, rowId);
                    const sideIds = this.cardData.map(card => String(card.id));
                    this.updateCardMarkersSelected(sideIds, this.getSelectedTableRows());
                });
            });
        },
        /**
         * Событие выбора цены в наборе
         * @param {Object} checkData - данные выбора
         * @param {String} keyPrices - ключ по которому вытаскиваются цены
         * @param {String} allPrices - ключ для добавления/удаления всех цен в строке
         */
        onCheckSubCheckboxFound(checkData = {}, keyPrices = 'prices', allPrices = '') {
            if (!this.isShare) {
                const {postData = {}, rowId = '-1', action = ''} = this.beforePostSyncDataCustom(checkData, this.tableCustomPricesSelected, this.kitCustomIdSelected, keyPrices, allPrices);
                this.postSyncDataCustom(postData, () => {
                    const postData = {set_id: this.kitCustomIdSelected, selected: [rowId]};
                    this.postTableDataRow(postData, (rows, kitItem) => {
                        this.updateKit(kitItem);
                        this.afterPostTableDataRow(rows, action, rowId);
                        const sideIds = this.cardData.map(card => String(card.id));
                        this.updateCardMarkersSelected(sideIds, this.getSelectedTableRows());
                    });
                });
            }
        },
        /**
         * Событие выбора всего найденного
         */
        onCheckAddAll() {
            if(this.kitFound.description > 1000){
                alert('Нельзя выбрать больше 1000 конструкций');
                return;
            }
            const postData = {set_id: this.kitCustomIdSelected, action: 'add-all', ids: ['1']};
            this.postSyncDataCustom(postData, () => {
                const postData = {set_id: this.kitCustomIdSelected};
                this.postTableDataRow(postData, (rows, kitItem) => {
                    this.updateKit(kitItem);
                    const indexFolder = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));
                    this.$refs.layoutFolder[indexFolder].clearRowTable();
                    this.afterPostTableDataRow(rows, 'add');
                    const sideIds = this.cardData.map(card => String(card.id));
                    this.updateCardMarkersSelected(sideIds, this.getSelectedTableRows());
                });
            });
        },
        beforeGetMarkers() {
            this.isUpdateLegend = false;
        },
        /**
         * Событие сработающее после получения маркеров набора
         * @param {String} kitId - идентификатор набора
         * @param {Object} objects
         * @param {Array} objects.markers - маркеры
         * @param {Array} objects.clusters - кластеры
         */
        async afterGetMarkersCustom(kitId = '-1', objects) {
            this.isUpdateLegend = true
            this.markerManager.addObjects(
                kitId,
                this.getColorKit(kitId),
                objects,
                this.kitsMarkersActive.includes(String(kitId))
            );

            this.updateClickedMarkerState()

            this.updateLegendMarkersColors("custom");
            this.isLoadingMap = false;
        },
        /**
         * Событие, сработающее после запроса на получения данных для строки при добавлении в набор
         * @property {Array} rows - строки
         * @property {String} action - действие
         * @property {String} rowId - идентификатор строки
         */
        afterPostTableDataRow(rows = [], action = '', rowId = '-1') {
            if (rows.length !== 0)
                this.updateTableCustom(rows, action);
            else {
                const index = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));
                this.$refs.layoutFolder[index].removeRowTable(rowId);
            }
        },
        /**
         * Обновить данные таблицы набора
         * @property {Array} rows - строки
         * @property {String} action - действие
         */
        updateTableCustom(rows = [], action = '') {
            const index = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));
            if (action === 'add')
                this.$refs.layoutFolder[index].addPriceTable(rows);
            else if (action === 'remove')
                this.$refs.layoutFolder[index].removePriceTable(rows);
        },
        /**
         * Обновить маркеры найдено
         */
        setMarkersSelectFound(targetKitId, targetMarkers = null, bufferMarkersSelected = null) {
            this.markerManager.updateMarkersState({
                targetKitId, targetMarkers, bufferMarkersSelected,
                kitsMarkersActive: this.kitsMarkersActive,
                mapFoundMarkersSelectedIds: this.mapFoundMarkersSelectedIds,
            });
        },
        /**
         * Обновить маркеры без цен
         */
        setMarkersSelectWithoutPrice() {
            this.markerManager.updateWpMarkersState(this.mapWithoutPriceSelectedCatalogIds, this.filterSelectedData.without_prices);
        },
        /**
         * Нарисовать маркеры найдено
         * @param {String} kitId - идентификатор набора
         */
        drawMarkersFound(kitId = '-1') {
            this.isLoadingMap = false;
            this.markerManager.drawMarkers([kitId])
        },

        /**
         * Выбрать маркера
         * @param {Object} sideIds - стороны для выбора
         * @param {String} kitId - идентификатор набора
         * @param {String} state - состояние маркеров (выбраны / не выбраны)
         * @param {Boolean} withoutPrices
         * @param {String} addAction
         * @param {Array<String>} quadkeys массив ключей кластеров
         */
        selectMarkers(sideIds = [], kitId = '-1', state = 0, withoutPrices = false, addAction = 'add-sides', quadkeys = []) {
            if(state){
                this.removeMarkerSides(sideIds, kitId, withoutPrices);
            }else{
                this.addMarkerPrices(sideIds, kitId, addAction, quadkeys);
            }
        },

        /**
         * Удаление конструкций из набора
         * @param {Object} sideIds - стороны для выбора
         * @param {String} kitId - идентификатор набора
         * @param {Boolean} withoutPrices
         */
        // eslint-disable-next-line no-unused-vars
        removeMarkerSides(sideIds, kitId, withoutPrices){
            // const action = withoutPrices ? 'catalog-sides-remove' :'remove-sides';
            const postData = {set_id: String(kitId) === this.kitFoundId ? this.kitCustomIdSelected : kitId, action: 'remove-sides', ids: sideIds};
            this.postSyncDataCustom(postData, () => {
                const index = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));
                this.$refs.layoutFolder[index].addPriceTable();

                const sideIdsGlobal = this.cardData.map(card => String(card.id));
                this.updateCardMarkersSelected(sideIdsGlobal, this.getSelectedTableRows());

                // const postData = {set_id: String(kitId) === this.kitFoundId ? this.kitCustomIdSelected : kitId, selected: sideIds};
                // this.postTableDataRow(postData, (rows, kitItem) => {
                //     this.updateKit(kitItem);
                //     if(rows.length === 0) {
                //         sideIds.forEach(rowId => {
                //             this.afterPostTableDataRow(rows, action, rowId);
                //         });
                //     }
                //     else {
                //         this.afterPostTableDataRow(rows, action, '-1');
                //     }
                //     const sideIdsGlobal = this.cardData.map(card => String(card.id));
                //     this.updateCardMarkersSelected(sideIdsGlobal, this.getSelectedTableRows());
                // });
            });
        },

        /**
         * Добавление размещений к набору
         * @param {Object} sideIds - стороны для выбора
         * @param {String} kitId - идентификатор набора
         * @param {String} addAction
         * @param {Array<String>} quadkeys массив ключей кластеров
         */
        addMarkerPrices(sideIds, kitId, addAction, quadkeys){
            // const action = 'add';
            const postData = {
                ...this.getBaseMarkerRequest(),
                view_zoom: this.markerManager.getCurrentZoom(),
                set_id: String(kitId) === this.kitFoundId ? this.kitCustomIdSelected : kitId,
                action: addAction,
                ids: sideIds,
                quadkeys
            };

            this.postSyncDataCustom(postData, () => {
                const index = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));
                this.$refs.layoutFolder[index].addPriceTable();

                const sideIdsGlobal = this.cardData.map(card => String(card.id));
                this.updateCardMarkersSelected(sideIdsGlobal, this.getSelectedTableRows());
            });
        },

        /**
         * Событие массового выбора маркеров
         * @param {Array} markers - маркеры
         * @param {Array} clusters - кластеры
         */
        onMassSelectMarkers(markers = [], clusters = []) {
            const quadKeys = clusters.map(cluster => cluster.quadkey);
            const markersRender = markers.filter(marker => Boolean(marker?.isRender ?? false) && Boolean(marker?.isVisible ?? false));
            const kitId = '0';
            let updateMarkers = [];
            let updateMarkersCatalog = [];
            const markersNoSelected = markersRender.filter((marker) => {
                const {extraData = {}/*, state = 0*/, id = null} = marker;
                const {kitId: kitIdMarker = '-1'} = extraData;
                if(/*parseInt(state) === 0 && */Number(kitIdMarker) >= Number(kitId)){
                    updateMarkers.push(id);
                    return true;
                }else{
                    return false;
                }
            });
            const markersWithoutPrice = markersRender.filter((marker) => {
                const {extraData = {}, state = 0, id = null} = marker;
                const {kitId: kitIdMarker = '-1'} = extraData;
                if(parseInt(state) === 0 && String(kitIdMarker) === '-2'){
                    updateMarkersCatalog.push(id);
                    return true;
                }else{
                    return false;
                }
            });
            // if(markersWithoutPrice.length > 100){
            //     alert('Нельзя добавить в набор более 100 конструкций без цен');
            //     return false;
            // }
            this.setMarkersSelectFound(this.kitFoundId, updateMarkers, updateMarkers);
            this.setMarkersSelectFound(-2, updateMarkersCatalog, updateMarkersCatalog);
            const catalogSideIds = markersWithoutPrice.reduce((sideIdsUnion, marker) => {
                const {extraData = {}} = marker;
                const {catalogSides = []} = extraData;
                const sideIdsAdded = Object.values(catalogSides).map(sideId => String(sideId)).filter(sideId => !sideIdsUnion.includes(sideId));
                return [...sideIdsUnion, ...sideIdsAdded];
            }, []);
            const sideIds = markersNoSelected.reduce((sideIdsUnion, marker) => {
                const {extraData = {}} = marker;
                const {sideIds = []} = extraData;
                const sideIdsAdded = sideIds.map(sideId => String(sideId)).filter(sideId => !sideIdsUnion.includes(sideId));
                return [...sideIdsUnion, ...sideIdsAdded];
            }, []);
            if(this.isWithoutPrices && (catalogSideIds.length > 0 || quadKeys.length > 0)) {
                this.selectWithoutPriceSides(catalogSideIds, quadKeys)
            }

            if (sideIds.length > 0 || quadKeys.length > 0)
                this.selectMarkers(
                    sideIds,
                    kitId,
                    0,
                    false,
                    'add-side-slots',
                    quadKeys
                );
        },

        onCheckTableRowWithoutPrices(tableCheckData = {}) {
            const catalogSideIds = [tableCheckData?.row?.id ?? ''];
            const isSelected = !!tableCheckData?.rowIsSelected;

            if (isSelected)
                this.selectWithoutPriceSides(catalogSideIds, [], 'catalog-sides-add', false);
            else
                this.selectWithoutPriceSides(catalogSideIds, [], 'catalog-sides-remove', false);
        },

        /**
         * Функция выбора конструкий без цен
         **/
        selectWithoutPriceSides(catalogSideIds, quadKeys = [], action = 'catalog-sides-add', isBound = true){
            const {latMin, latMax, lngMin, lngMax} = this.$refs.mapView.getBounds();
            const postData = {
                set_id: this.kitCustomIdSelected,
                // action: 'catalog-sides-add',
                action,
                ids: catalogSideIds,
                view_zoom: this.markerManager.getCurrentZoom(),
                bound: isBound ? [
                    [latMin, lngMin],
                    [latMax, lngMax]
                ] : [],
                map_driver: this.mapDriver,
                quadkeys: quadKeys,
                radius: this.poiRadius,
                points: Object.values(this.poiPointsDetailed),
                side_turn_poi: this.poiRadiusDirectionType === ''
                    ? null : this.poiRadiusDirectionType
            };

            this.postSyncDataCustom(postData, (sideIds) => {
                const postData = {set_id: this.kitCustomIdSelected, selected:sideIds};
                this.postTableDataRow(postData, (rows, kitItem) => {
                    this.updateKit(kitItem);
                    if(rows.length){
                        this.afterPostTableDataRow(rows, 'add', '-1');
                    } else
                        this.afterPostTableDataRow(rows, 'remove', catalogSideIds[0]);
                    const sideIdsGlobal = this.cardData.map(card => String(card.id));
                    this.updateCardMarkersSelected(sideIdsGlobal, this.getSelectedTableRows());
                });
            });
        },
        switchWithoutPriceSelection(marker)
        {
            const {extraData = {}} = marker;
            if(
                Object.values(extraData.catalogSides).length < 2
                && !Object.keys(this.mapWithoutPriceSelectedCatalogIds).includes(Object.values(extraData.catalogSides)[0])
            ){
                this.setMarkersSelectFound('-2',[marker.id], [marker.id]);
                this.selectWithoutPriceSides(Object.values(extraData.catalogSides));
                return false;
            }else if(
                Object.values(extraData.catalogSides).length < 2
                && Object.keys(this.mapWithoutPriceSelectedCatalogIds).includes(Object.values(extraData.catalogSides)[0])
            ){
                let sideIdsToRemove = [];
                Object.values(extraData.catalogSides).forEach((catalogSideId) => {
                    if(Object.keys(this.mapWithoutPriceSelectedCatalogIds).includes(catalogSideId)){
                        sideIdsToRemove.push(this.mapWithoutPriceSelectedCatalogIds[catalogSideId]);
                    }
                })
                this.selectMarkers(sideIdsToRemove, this.kitCustomIdSelected, 1, true);
                return false;
            }
            // else {
            //     this.onSelectMarkerRight(marker)
            // }
            let sideList = [];
            Object.keys(extraData.catalogSides).forEach((code) => {
                sideList.push({
                    name: code,
                    value: extraData.catalogSides[code],
                    checked: Object.keys(this.mapWithoutPriceSelectedCatalogIds).includes(extraData.catalogSides[code])
                });
            });
            sideList = sideList.sort((strA, strB) => {
                if (strA.name > strB.name)
                    return 1;
                if (strA.name < strB.name)
                    return -1;
                return 0;
            });
            this.currentSelectionSideMode = 'without_prices';
            this.currentSideCheckList = sideList;
            this.$refs.mapView.initSideSelectionBox({lat:marker.lat, lng: marker.lng}, sideList)
        },
        /**
         * Событие выбора маркера
         * @param {Object} marker - маркер
         */
        onSelectMarker(marker = {}) {
            if (!this.isShare) {
                const {extraData = {}, state = 0} = marker;
                const {kitId = '-1'} = extraData;
                let resultState =  kitId > 0 ? 1 : state;
                if(kitId == '-2'){
                    this.switchWithoutPriceSelection(marker);
                    return false;
                }

                if (marker.extraData.type !== 'poi') {
                    if(extraData.sideIds.length < 2){
                        this.setMarkersSelectFound(this.kitFoundId,[marker.id], resultState ? [] : [marker.id]);
                        this.selectMarkers(extraData.sideIds, kitId, resultState);
                    }
                    // else {
                    //     this.onSelectMarkerRight(marker)
                    // }
                    // return true;
                    const postData = {selectedMarker: [marker.id]};
                    let sideList = [];
                    let pushedSides = [];
                    let index = this.kitCustoms.findIndex(kit => String(kit.id) === this.kitCustomIdSelected);
                    const tableRowsPricesIdsSelected = this.$refs.layoutFolder[index].tableRowsPricesIdsSelected || [];
                    const kitRows = this.$refs.layoutFolder[index].tableRows || [];
                    this.postTableDataRowFound(postData, (rows) => {
                        rows.forEach(row => {
                            pushedSides.push(row.id);
                            sideList.push({
                                name: row.full_code,
                                value: row.id,
                                checked: Object.keys(tableRowsPricesIdsSelected).includes(row.id),
                                description: row.is_digital ? `(${ row?.video_time ?? 0 } сек. ${ row?.video_block_outputs ?? 0 } выходов)` : ''
                            });
                        });
                        kitRows.filter(item => item.marker_id === marker.id).forEach(row => {
                            if(!pushedSides.includes(row.id)){
                                pushedSides.push(row.id);
                                sideList.push({
                                    name: row.full_code,
                                    value: row.id,
                                    checked: Object.keys(tableRowsPricesIdsSelected).includes(row.id),
                                    description: row.is_digital ? `(${ row?.video_time ?? 0 } сек. ${ row?.video_block_outputs ?? 0 } выходов)` : ''
                                });
                            }
                        });
                        sideList = sideList.sort((strA, strB) => {
                            if (strA.name > strB.name)
                                return 1;
                            if (strA.name < strB.name)
                                return -1;
                            return 0;
                        })
                        if(sideList.length < 2){
                            this.selectMarkers(pushedSides, kitId, state);
                            return true;
                        }
                        this.currentSelectionSideMode = 'default';
                        this.currentSideCheckList = sideList;
                        this.$refs.mapView.initSideSelectionBox({lat:marker.lat, lng: marker.lng}, sideList);
                    });
                }
                if (marker.extraData.type === 'poi') {
                    const poiInfo = {
                        address: marker.extraData.address,
                        description: marker.extraData.description,
                    };
                    this.$refs.mapView.initWindowInfoPoi({lat:marker.lat, lng: marker.lng}, poiInfo);
                }

            }
        },
        /**
         * Событие выбора стороны в мелком окошке
         * @param {Object} data
         */
        onAfterSelectSideInBox(data){
            let {sideIds = [], state} = data;
            let currentSideCheckList = [...this.currentSideCheckList];
            currentSideCheckList.forEach((item) => {
                sideIds.forEach((sideId) => {
                    if(sideId === item.value){
                        item.checked = !state
                    }
                });
            })
            this.currentSideCheckList = [...currentSideCheckList];
            if(this.currentSelectionSideMode === 'without_prices' && state === 1){
                let sideIdsToRemove = [];
                sideIds.forEach((catalogSideId) => {
                    if(Object.keys(this.mapWithoutPriceSelectedCatalogIds).includes(catalogSideId)){
                        sideIdsToRemove.push(this.mapWithoutPriceSelectedCatalogIds[catalogSideId]);
                    }
                })
                let markerIds = this.getMarkerWPIdsBySidesInBox(sideIds, state);
                this.setMarkersSelectFound('-2', markerIds, [])
                this.selectMarkers(sideIdsToRemove, this.kitCustomIdSelected, state, true);
            }else if(this.currentSelectionSideMode === 'default'){
                let markerIds = this.getMarkerFoundIdsBySidesInBox(sideIds, state);
                this.setMarkersSelectFound(this.kitFoundId, markerIds, state ? [] : markerIds)
                this.selectMarkers(sideIds, this.kitCustomIdSelected, state);
            }else {
                let markerIds = this.getMarkerWPIdsBySidesInBox(sideIds, state);
                this.setMarkersSelectFound('-2', markerIds, markerIds)
                this.selectWithoutPriceSides(sideIds);
            }
        },
        /**
         * Событие правого клика по маркеру
         * @param {Object} marker - маркеры
         */
        onSelectMarkerRight(marker = {}) {
            const {id = '-1', extraData = {}} = marker;
            const {kitId = '-1', sideIds = [], catalogSides = {}} = extraData;
            if(kitId == '-2'){
                let index = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));
                const tableRowsPricesIdsSelected = this.$refs.layoutFolder[index].tableRowsCatalogIdsPricesSelected || {};
                let tableRowPricesIdsSelected = Object.assign({}, tableRowsPricesIdsSelected);
                Object.keys(tableRowsPricesIdsSelected).forEach(rowId => {
                    if (!Object.values(catalogSides).includes(String(rowId)))
                        delete tableRowPricesIdsSelected[rowId];
                });
                const postData = {marker_id: id}
                this.postMarkerCatalogData(postData, (rows) => {
                    this.isCardVisible = true;
                    this.cardData = rows;
                    this.cardMarker = marker;
                    this.cardMarkerSelected = tableRowPricesIdsSelected;
                    let index = this.kitCustoms.findIndex(kit => String(kit.id) === this.kitCustomIdSelected);
                    this.cardKitPrices = this.$refs.layoutFolder[index].tableCatalogPrices || {};
                });
            }else {
                let index = this.kitCustoms.findIndex(kit => String(kit.id) === String((String(kitId) === this.kitFoundId) ? this.kitCustomIdSelected : kitId));
                const tableRowsPricesIdsSelected = this.$refs.layoutFolder[index].tableRowsPricesIdsSelected || {};
                let tableRowPricesIdsSelected = Object.assign({}, tableRowsPricesIdsSelected);
                Object.keys(tableRowsPricesIdsSelected).forEach(rowId => {
                    if (!sideIds.includes(String(rowId)))
                        delete tableRowPricesIdsSelected[rowId];
                });
                const postData = {marker_id: id, set_id: kitId > 0 ? kitId : null}
                this.postMarkerData(postData, (rows) => {
                    this.isCardVisible = true;
                    this.cardData = rows;
                    this.cardMarker = marker;
                    this.cardMarkerSelected = tableRowPricesIdsSelected;
                    this.cardKitPrices = this.$refs.layoutFolder[index].tableRowsPrices || {};
                });
            }

        },
        /**
         * Выбор цены в карточке
         * @param {String} priceId - id цены
         * @param {String} sideId - id стороны
         */
        onCheckPrice(priceId = '-1', sideId = '-1') {
            if (!this.isShare) {
                const {extraData = {}} = this.cardMarker;
                // const {kitId = '-1', sideIds = []} = extraData;
                let {kitId = '-1'} = extraData;
                // const sideIds = this.cardData.map(card => String(card.id));
                const {pricesReduced = []} = this.afterPostTableDataRowFound(this.cardData);
                const pricesFiltered = pricesReduced.filter(id => String(id) === String(priceId));
                let tableRowPricesIdsSelected;
                let tableRowSideIdSelected;
                let tableRowsSideIdsSelected;
                let isCatalog = false;

                if(kitId === '-2'){
                    isCatalog = true;
                    kitId = this.kitFoundId;
                    let index = this.kitCustoms.findIndex(kit => String(kit.id) === String(this.kitCustomIdSelected));
                    const tableRowsPricesIdsSelected = this.$refs.layoutFolder[index].tableRowsCatalogIdsPricesSelected || [];
                    tableRowsSideIdsSelected = this.$refs.layoutFolder[index].tableRowsCatalogIdsSelected || [];
                    tableRowPricesIdsSelected = tableRowsPricesIdsSelected[sideId] || [];
                } else {
                    let index = this.kitCustoms.findIndex(kit => String(kit.id) === String(String(kitId) === this.kitFoundId ? this.kitCustomIdSelected : kitId));
                    const tableRowsPricesIdsSelected = this.$refs.layoutFolder[index].tableRowsPricesIdsSelected || [];
                    tableRowPricesIdsSelected = tableRowsPricesIdsSelected[sideId] || [];
                }
                let action;

                if(!tableRowPricesIdsSelected.includes(String(priceId)) && isCatalog){
                    tableRowSideIdSelected = sideId;
                    action = 'catalog-sides-add';
                } else if(!tableRowPricesIdsSelected.includes(String(priceId)) && !isCatalog){
                    tableRowSideIdSelected = sideId;
                    action = 'add';
                } else if(isCatalog){
                    tableRowSideIdSelected = tableRowsSideIdsSelected[sideId];
                    action = 'remove';
                } else {
                    tableRowSideIdSelected = sideId;
                    action = 'remove';
                }

                const postData = {
                    set_id: String(kitId) === this.kitFoundId ? this.kitCustomIdSelected : kitId,
                    action,
                    ids: action == 'catalog-sides-add' ? [tableRowSideIdSelected] : pricesFiltered
                };
                this.postSyncDataCustom(postData, (catalogSideIds) => {
                    const postData = {
                        set_id: this.kitCustomIdSelected,
                        selected: action == 'catalog-sides-add' ? catalogSideIds : [tableRowSideIdSelected]
                    };
                    this.postTableDataRow(postData, (rows, kitItem) => {
                        this.updateKit(kitItem);
                        if(rows.length === 0) {
                            this.afterPostTableDataRow(rows, 'remove', tableRowSideIdSelected);
                        }
                        else {
                            this.afterPostTableDataRow(rows, 'add', '-1');
                        }
                        // const {extraData = {}} = this.cardMarker;
                        // const {kitId = '-1'} = extraData;
                        // let index = this.kitCustoms.findIndex(kit => String(kit.id) === String(kitId == '-2' || String(kitId) === this.kitFoundId ? this.kitCustomIdSelected : kitId));
                        // if(kitId == '-2'){
                        //     this.updateCardMarkersSelected(sideIds, this.$refs.layoutFolder[index].tableRowsCatalogIdsPricesSelected);
                        // }else{
                        //     this.updateCardMarkersSelected(sideIds, this.$refs.layoutFolder[index].tableRowsPricesIdsSelected);
                        // }
                    });
                });
            }
        },
        /**
         * Обновить выбранные цены в карточке
         * @param {Array} sideIds - стороны
         * @param {Object} tableRowsPricesIdsSelected - выбранные цены в строке
         */
        updateCardMarkersSelected(sideIds = [], tableRowsPricesIdsSelected = {}) {
            let tableRowPricesIdsSelected = {};
            Object.keys(tableRowsPricesIdsSelected).forEach(rowId => {
                if (sideIds.includes(String(rowId)))
                    tableRowPricesIdsSelected[rowId] = tableRowsPricesIdsSelected[rowId];
            });
            this.cardMarkerSelected = tableRowPricesIdsSelected;
        },
        onRemoveFolder(id) {
            console.log(id);
            if(this.kitCustoms.length > 1) {
                this.onToggleMarkersKit(id, 'custom');
                this.postRemoveKit(id, (id) => {
                    this.afterPostRemoveKit(id);

                    this.onToggleTableKit(this.kitCustoms[0]?.id, 'custom');
                });
            }
            else
                alert('Нельзя удалить последний набор');
        },
        onMoveToBudget(id){
            this.$router.push({path: '/price?setId=' + id});
        },
        /**
         * Дублирование набора
         * @param {String} id
         */
        async onDuplicate(id){
            const isConfirm = await this.$confirm('Вы уверены что хотите дублировать набор?');

            // if (!confirm("Вы уверены что хотите дублировать набор?"))
            if (!isConfirm)
                return;
            this.isLoadingKitsCustom = true;
            this.postDuplicateKit(id, (kit) => {
                this.afterPostCreateKit(kit, false);
                this.isLoadingKitsCustom = false;
            });
        },

        toggleAdmetrix(kitItemId = "") {
            const kitCustom = this.kitCustoms.find(kitItem => kitItem.id === kitItemId);
            const isKitAdMetrix = this.adMetrix.some(adMetrixItem => adMetrixItem.id === kitItemId);

            if (!isKitAdMetrix)
                this.adMetrix.push({ id: kitItemId, name: kitCustom?.title, type: "group" });
        },
        closeAdMetrix(adMetrixItemId = "") {
            this.adMetrix = this.adMetrix.filter(adMetrixItem => adMetrixItem.id !== adMetrixItemId);
        },
        /**
         * Получить от сервера статусы маркеров,
         * изменить формат данных для передачи в LegendPanel
         * @param {Array} statuses - Статусы маркеров
         */
        setMarkersStatuses(statuses) {
            const markersStatuses = [];
            const keysStatuses = Object.keys(statuses);
            const valuesStatuses = Object.values(statuses);
            const findColor = (key) => {
                const markerItem = this.markerManager.getMarkers('-1').find((el) => el.status === key);
                if (markerItem !== undefined) {
                    return String(markerItem.color_legend);
                }
                return '';
            }

            keysStatuses.forEach((key, index) => {
                markersStatuses.push({
                    key,
                    value: valuesStatuses[index],
                    color: findColor(key),
                });
            });
            const allKeysStatuses = keysStatuses;
            allKeysStatuses.push('without_price');
            if (this.filterSelectedData?.without_prices) {
                markersStatuses.push({
                    color:'#848484',
                    key: 'without_price',
                    value:'Без цены',
                });
            }
            this.markersStatuses = markersStatuses;
            this.setMarkersStatusesListDefault(markersStatuses);
            if (this.allActiveLegendPanelMarkersStatuses.length === 0) {
                this.setAllActiveMarkerStatuses([...allKeysStatuses]);
            }
            this.setActiveMarkerStatuses(allKeysStatuses);
        },
        /**
         * Отобразить маркеры по выбранным статусам в легенде
         */
        onChangeMarkers() {
            if (this.activeLegendPanelMarkersStatuses.length !== 0) {
                this.markerManager.updateMarkers(this.activeLegendPanelMarkersStatuses)
            } else {
                this.markerManager.hideMarkers(['0', '-2']);
            }
        },

        onClickCell(data){
            const {row = {}, kitId: kitIdClicked = null} = data;
            const {id = null, lat = null, lng = null, marker_id: markerId = null} = row;

            if(data.attribute === 'address'){
                this.$refs.mapView.focusMap(lat, lng, 15);
                this.onSelectMarkerRight({
                    id: markerId,
                    extraData: {
                        kitId: kitIdClicked,
                        sideIds: [id]
                    }
                });

                this.setMarkerClicked(markerId, kitIdClicked);
            }
        },

        updateClickedMarkerState() {
            if(this.isCardVisible){
                const {id: markerId = null, extraData: {kitId:kitIdClicked = null}} = this.cardMarker;
                this.setMarkerClicked(markerId, kitIdClicked);
            }
        },

        setMarkerClicked(markerId, kitIdClicked) {
           this.markerManager.setMarkerClicked(markerId, kitIdClicked);
        },
        /**
         * Экспорт шаблона
         * @returns {Promise<void>}
         */
        async onExportTemplate(isRemoveDoubles){
            if(this.exportingSetId === null){
                alert('Что то пошло не так');
            }
            let bodyPost = {
                set_id: this.exportingSetId,
                is_double_sides: !isRemoveDoubles
            };
            if(this.currentTemplate.id > 0){
                bodyPost.template_id = this.currentTemplate.id;
            }
            this.postExportKitQueue(bodyPost, (history, isTask) => {
                if(isTask){
                    this.$notify.addNotification({
                        type: 'success',
                        title: 'Задача на экспорт успешно добавлена в очередь',
                        description: 'Создание файла может занять некоторое время. Пожалуйста, подождите',
                        duration: Infinity,
                        position: 'bottom-right'
                    });
                }

                const {status = 0, url = null} = history;
                if(Number(status) === 2 && url !== null){
                    this.afterPostExportKit(url);
                }
                this.addHistoryItem(history);
            }, (errorMsg = '') => {
                if (errorMsg) {
                    this.$notify.addNotification({
                        type: 'error',
                        title: 'Не удалось создать задачу на выполнение экспорта',
                        description: errorMsg,
                        duration: Infinity,
                        position: 'bottom-right'
                    });
                }
            });
        },
        /**
         * Получение списка шаблонов
         * @returns {Promise<void>}
         */
        async onGetTemplates(){
            this.postTemplateList((templates) => {
                this.afterPostTemplateList(templates);
            });
        },
        /**
         * Сохранение шаблона
         * @param toSaveTemplate
         * @returns {Promise<void>}
         */
        async onSaveTemplate(toSaveTemplate){
            this.postTemplateSave(toSaveTemplate, (savedTemplate) => {
                this.afterPostTemplateSave(toSaveTemplate, savedTemplate);
            });
        },
        /**
         * Удаление шаблона
         * @returns {Promise<void>}
         */
        async onRemoveTemplate(){
            this.postTemplateRemove(this.currentTemplate.id, () => {
                this.afterPostTemplateRemove();
            });
        },


        /**
         * Нарисовать маркеры пои
         * @param {Array} dataPoi - Список POI данной группы
         */
         onDrawPoiMarkers(dataPoi) {
            this.$refs.mapView.redrawMarkers(() => false, dataPoi, true, false);
        },

        setFilterPoiRadiusDefault() {
            this.onFilterPoiRadius(0);

            this.$refs.layoutModules?.setFilterPoiRadiusDefault();
        },

        /**
         * Фильтрация точек по радиусу
         *
         * @param {Number} radius
         * @param {String} directionType
         */
        onFilterPoiRadius(radius, directionType){
            this.poiRadiusDirectionType = directionType
            this.poiRadius = Number(radius);
            this.poiPointsDetailed = {};
            if(this.poiRadius > 0){
                this.$refs.mapView.updateMarkers((marker) => {
                    const { extraData = {}, lat = 0, lng = 0 } = marker;
                    const {
                        type = 'default' ,
                        groupId = '',
                        groupName = '',
                        address = '',
                        // description = '',
                        id = ''
                    } = extraData;

                    if (type === 'poi') {
                        const key = id + '-' + groupId;
                        if(typeof this.poiPointsDetailed[key] === 'undefined'){
                            this.poiPointsDetailed[key] = {
                                group_name: groupName,
                                address,
                                // description,
                                lat,
                                lng
                            }
                        }
                    }
                }, false);
            }

            this.tableFoundPageNumber = 1;
            this.postTableDataFound(this.tableFoundRequestBody, (_, rows) => {
                this.afterPostTableData(rows, 'prices', true);
            });

            setTimeout(() => {
                let index = this.kitCustoms.findIndex(kit => String(kit.id) === this.kitCustomIdSelected);
                this.$refs.layoutFolder[index]?.updateDataCustomKit();
            }, 400);

            this.onTriggerBounds();
        },

        /**
         * Обновить цвет маркеров
         * @param {String} groupId
         * @param {String} color
         */
        onUpdateColorMarkers(groupId, color){
            this.$refs.mapView.updateMarkers((marker) => {
                const {extraData = {}} = marker;
                const {groupId: markerGroupId = "", type = ""} = extraData;
                if (groupId === markerGroupId && type === "poi") {
                    marker.color = color;
                    marker.fill_color = color;
                    marker.src = "";
                    marker.iconType = "poi";
                    marker.updateIcon(marker.iconType, false);
                }
            }, false);
        },

        /**
         * Обновить иконки маркеров
         * @param {String} groupId
         * @param {String} src
         */
        onUpdateIconMarkers(groupId, src){
            this.$refs.mapView.updateMarkers((marker) => {
                const {extraData = {}} = marker;
                const {groupId: markerGroupId = "", type = ""} = extraData;
                if (groupId === markerGroupId && type === "poi") {
                    marker.src = src;
                    marker.updateIcon(marker.iconType, false);
                }
            }, false);
        },

        /**
         * Удалить маркеры пои
         * @param {String} groupId
         */
        onClearPoiMarkers(groupId){
            this.$refs.mapView.redrawMarkers((marker) => {
                const {extraData = {}} = marker;
                const {groupId: markerGroupId = "", type = ""} = extraData;
                return groupId === markerGroupId && type === "poi";
            }, [], true, false);
        },

        /**
         * Изменить активность маркера
         * @param {Object} marker
         */
        onTogglePoiMarker(marker){
            const {extraData = {}} = marker;
            const {id: poiId = "", groupId = "", isActive = false} = extraData;
            if(!isActive){
                this.$refs.mapView.redrawMarkers((marker) => {
                    const {extraData = {}} = marker;
                    const {groupId: markerGroupId = "", type = "", id = ""} = extraData;
                    return groupId === markerGroupId && id === poiId && type === "poi";
                }, [], true, false);
            }else{
                this.$refs.mapView.redrawMarkers(() => false, [marker], true, false);
            }
        },

        onDrawCompetitorMarkers(groupId, markers){
            let updatedMap = markers.map((marker) => {
                return String(marker.id);
            });
            let updatedMarkers = [...markers];
            this.$refs.mapView.redrawMarkers((marker) => {
                const {extraData = {}, id: markerId = ""} = marker;
                const {groupId: markerGroupId = "", type = ""} = extraData;
                if(groupId === markerGroupId && type === "competitor" && updatedMap.includes(markerId)){
                    updatedMarkers = updatedMarkers.filter(updatedMarker => String(updatedMarker.id) !== String(markerId))
                }
                return groupId === markerGroupId && type === "competitor" && !updatedMap.includes(String(markerId));
            }, [], true, false);
            if(updatedMarkers.length){
                this.$refs.mapView.redrawMarkers(() => false, updatedMarkers, true, false);
            }
        },

        onClearCompetitorMarkers(groupId){
            this.$refs.mapView.redrawMarkers((marker) => {
                const {extraData = {}} = marker;
                const {groupId: markerGroupId = "", type = ""} = extraData;
                return groupId === markerGroupId && type === "competitor";
            }, [], true, false);
        },

        onChangeCompetitorColor(groupId, color){
            this.$refs.mapView.updateMarkers((marker) => {
                const {extraData = {}} = marker;
                const {groupId: markerGroupId = "", type = ""} = extraData;
                if (groupId === markerGroupId && type === "competitor") {
                    Object.keys(marker.sidesColors).forEach((sideName) => {
                        marker.sidesColors[sideName] = marker.correctionColor(color);
                    })
                    marker.updateIcon(marker.iconType, false);
                }
            }, false);
        },

        onCompleteMatching(newKit){
            this.afterPostCreateKit(newKit);
            // this.onToggleMarkersKit(newKit.id, 'custom');
            // this.onToggleTableKit(newKit.id, 'custom');

            // this.isLoadingKitsCustom = true;
            // this.postKitsList((kits) => {
            //     this.afterPostKitsList(kits);
            //     this.$nextTick(() => {
            //         this.onToggleMarkersKit(newKit.id, 'custom');
            //         this.onToggleTableKit(newKit.id, 'custom');
            //     });
            //     this.isLoadingKitsCustom = false;
            // });
        },

        onTogglePoiAddress(marker) {
            const {lat = null, lng = null} = marker
            this.$refs.mapView.focusMap(lat, lng, 15);
        },

        getPoiCoordsByClick(coords) {
            this.moiPoiCoords = coords
        },

        onMapClick(coords) {
            this.getPoiCoordsByClick(coords)
        },

        /**
         * Проверка на смену города
         * @returns {boolean}
         */
        checkMapScale(){
            const {id = null, lat = null, lng = null, zoom = null} = this.currentCity;
            if(id !== null && String(id) !== this.currentCityId){
                this.$refs.mapView.focusMap(lat, lng, zoom);
                this.currentCityId = String(id);
                return true;
            }
            return false;
        },

        getBaseMarkerRequest(bound = null) {
            const {latMin, latMax, lngMin, lngMax} = bound ?? this.$refs.mapView.getBounds();

            return {
                bound: [
                    [latMin, lngMin],
                    [latMax, lngMax]
                ],
                radius: this.poiRadius,
                points: this.poiPoints,
                map_driver: this.mapDriver,
                side_turn_poi: this.poiRadiusDirectionType === ''
                    ? null : this.poiRadiusDirectionType,
            }
        },

        /** Обновление маркеров при скролле и перемещении карты */
        onBoundsChanged(bound,zoom, isForce = false){
            if(!this.markerManager.isNeedUpdateMarkers(bound, zoom) && !isForce){
                console.log("update not need");
                return;
            }

            if(!this.kitsMarkersActive.length && !this.isWithoutPrices){
                return;
            }

            console.log("updating markers");

            const baseZoomRequest = this.getBaseMarkerRequest(bound);

            this.postGetClusterZoom(
                {
                    ...baseZoomRequest,
                    filter_params: {
                        ...this.filterSelectedData,
                        without_prices: this.isWithoutPricesMarkersActive
                    },
                    is_found: this.isFoundMarkersActive,
                    set_ids: this.activeMarkerKitIds
                },
                (zoomResponse) => {
                    this.clusterZoomResponseHandler(baseZoomRequest, zoomResponse);
                }
            )
        },

        /**
         * Обработка ответа кластеризации определения приближения кластеров
         * @param {Object} zoomRequest
         * @param {Object} zoomResponse
         */
        clusterZoomResponseHandler(zoomRequest, zoomResponse){
            const {view_zoom: viewZoom = null, is_grouping: isGrouping = true} = zoomResponse;
            this.markerManager.setCurrentZoom(viewZoom)

            const baseMarkerRequest = {
                ...zoomRequest,
                view_zoom: viewZoom,
                is_grouping: isGrouping,
            }

            //без цен
            this.isWithoutPrices = !!this.filterSelectedData.without_prices
            if(this.isWithoutPrices && this.isWithoutPricesMarkersActive){
                this.isLoadingMap = true
                this.postClustersDataWithoutPrices(
                    {...baseMarkerRequest, filter_params: this.filterSelectedData},
                    this.clusterWpResponseHandler
                );
            }else{
                this.markerManager.removeObjects('-2');
            }

            //найдено
            if(this.isFoundMarkersActive){
                this.isLoadingMap = true
                this.isUpdateLegend = false;

                this.postMarkersDataFound(
                    {...baseMarkerRequest, filter_params: this.filterSelectedData},
                    this.clusterFoundResponseHandler
                );
            }

            //наборы
            this.activeMarkerKitIds.forEach((kitId) => {
                this.isLoadingMap = true;
                this.isUpdateLegend = false;

                this.postMarkersAndClustersDataCustom(
                    {...baseMarkerRequest, set_id: kitId},
                    (kitResponse) => {
                        this.clusterKitResponseHandler(kitId, kitResponse);
                    }
                );
            })
        },

        /**
         * Обработка ответа кластеризации конструкицй без цен
         * @param {Object} wpResponse
         */
        clusterWpResponseHandler(wpResponse){
            this.markerManager.addObjects(
                '-2',
                '#848484',
                wpResponse,
                true,
                Object.keys(this.mapWithoutPriceSelectedCatalogIds)
            )
            this.updateClickedMarkerState();
            this.updateLegendMarkersColors("without_prices");
            this.isLoadingMap = false;
        },

        /**
         * Обработка ответа кластеризации найденных конструкций
         * @param foundResponse
         */
        clusterFoundResponseHandler(foundResponse){
            const {statuses, bound: loadedBound = {}} = foundResponse;

            const color = this.getColorKit(this.kitFoundId);
            this.markerManager.addObjects(this.kitFoundId, color, foundResponse, this.isFoundMarkersActive);

            this.isUpdateLegend = true;

            this.updateClickedMarkerState();

            this.setMarkersSelectFound(this.kitFoundId);
            this.setMarkersStatuses(statuses);

            this.markerManager.setLoadedBound(loadedBound)
            this.updateLegendMarkersColors("found");

            this.isLoadingMap = false;
        },

        /**
         * Обработка ответа кластеризации наборов
         * @param {String} kitId
         * @param {Object} kitResponse
         */
        clusterKitResponseHandler(kitId, kitResponse) {
            const {bound: loadedBound = {}} = kitResponse;

            this.markerManager.setLoadedBound(loadedBound)

            this.isUpdateLegend = true
            this.markerManager.addObjects(
                kitId,
                this.getColorKit(kitId),
                kitResponse,
                this.kitsMarkersActive.includes(String(kitId))
            );

            this.updateClickedMarkerState()

            this.updateLegendMarkersColors("custom");
            this.isLoadingMap = false;
        },

        /**
         * Приближение при клике на кластер
         * @param {Object} marker
         */
        onClickCluster(marker) {
            const {lat, lng} = marker;
            this.$refs.mapView.focusMap(lat, lng, this.markerManager.getCurrentZoom() + 2);
        },

        /** Кэш отложенных функция */
        onReadyMap() {
            this.runTriggers()
        },

        /**
         * Изменение типа иконок
         * @param {String} currentIconType
         */
        onChangeIconType(currentIconType) {
            this.markerManager.setCurrentIconType(currentIconType)
        }
    }
}
</script>

<style lang="scss" scoped>
.page-bayuerdesk {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    position: relative;
    //padding: 5px;

    &__map-widget-ad-metrix {
        position: absolute;
        bottom: 0;
    }

    &__loading {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99999;
        background: #fff;
        padding: 0px 40px 40px 40px;

        &-enter-active, &-leave-active {
            transition: opacity 300ms;
        }

        &-enter, &-leave-to {
            opacity: 0;
        }
    }

    &-map {
        flex-grow: 1;
        width: 100%;
        // height: 100px;
        //margin-top: 10px;
        position: relative;
        //border-radius: 10px;

        &__progressbar {
            position: absolute;
            z-index: 1;
        }

        &__wrapper {
            overflow: hidden;
            border-radius: inherit;
            height: 100%;
            width: 100%;
        }

        &__construction-card {
            position: absolute;
            right: 10px;
            top: 10px;
            max-height: calc(100% - 20px);
            // max-height: 500px;
            z-index: 40;
            width: 700px;
        }
    }

    &__map-view {
        width: 100%;
        height: 100%;
        position: relative;
        overflow: hidden;
        border-radius: inherit;
        display: flex;

        &-content {
            &-map {
                flex: 1;
            }

            &_half {
                position: relative;
                height: 100%;
            }
        }

        &-resizer {
            width: 5px;
            height: 100%;
            background-color: #4A92F6;
            cursor: e-resize;
        }
    }
}
</style>
